import lozad from 'lozad'

export enum LazyLoadMethodType {
  default = 'default',
  aggressive = 'aggressive',
}

/**
 * The 'default' lazy loading behavior will only load images once the top of image
 * element enters the viewport.
 */
export const defaultLazyLoad = lozad()

/**
 * The 'aggressive' lazy loading behavior will load images once the image is 50% away
 * from the bottom of the viewport.
 */
export const aggressiveLazyLoad = lozad('.lozad', {rootMargin: '50% 0px'})
